import { createContext, useContext, useEffect, useState } from 'react';
import { useGetUserSubscriptions } from './useGetUserSubscriptions';
import isEmpty from 'lodash/isEmpty';

const useUserSubscriptions = () => {
  const { getUserSubscriptions, userSubscriptions, isFetching } = useGetUserSubscriptions();
  const [isCommonButtonSubscribed, setCommonButtonSubscribed] = useState(false);

  useEffect(() => {
    if (!isEmpty(userSubscriptions)) return;
    getUserSubscriptions();
  }, []);

  return {
    userSubscriptions,
    isFetching,
    getUserSubscriptions,
    isCommonButtonSubscribed,
    setCommonButtonSubscribed,
  };
};

type UserSubscriptionsContextType = ReturnType<typeof useUserSubscriptions>;

export const UserSubscriptionsContext = createContext<UserSubscriptionsContextType>(null);

export const useUserSubscriptionsContext = () => {
  const context = useContext(UserSubscriptionsContext);
  if (!context) {
    throw new Error('useUserSubscriptionsContext must be used within the UserSubscriptionsContext');
  }
  return context;
};

const UserSubscriptionsContextProvider = ({ children }) => (
  <UserSubscriptionsContext.Provider value={ useUserSubscriptions() }>
    { children }
  </UserSubscriptionsContext.Provider>
);

export default UserSubscriptionsContextProvider;
